var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1BillionHoverstage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 62,
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_1003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4572 60.0745H6.54273C3.5866 60.0745 1.18958 57.6774 1.18958 54.7213V6.54286C1.18958 3.58672 3.5866 1.1897 6.54273 1.1897H73.4572C76.4134 1.1897 78.8104 3.58672 78.8104 6.54286V54.7213C78.8104 57.6774 76.4134 60.0745 73.4572 60.0745Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18958 11.896H78.8104",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21 7.78835C20.0919 7.78835 20.8067 7.07349 20.8067 6.19166C20.8067 5.30983 20.0919 4.59497 19.21 4.59497C18.3282 4.59497 17.6133 5.30983 17.6133 6.19166C17.6133 7.07349 18.3282 7.78835 19.21 7.78835Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8494 7.78835C14.7313 7.78835 15.4461 7.07349 15.4461 6.19166C15.4461 5.30983 14.7313 4.59497 13.8494 4.59497C12.9676 4.59497 12.2527 5.30983 12.2527 6.19166C12.2527 7.07349 12.9676 7.78835 13.8494 7.78835Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48884 7.78835C9.37067 7.78835 10.0855 7.07349 10.0855 6.19166C10.0855 5.30983 9.37067 4.59497 8.48884 4.59497C7.60701 4.59497 6.89215 5.30983 6.89215 6.19166C6.89215 7.07349 7.60701 7.78835 8.48884 7.78835Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7063 26.6172H66.7658C68.9844 26.6172 70.7806 28.4135 70.7806 30.6321C70.7806 32.8506 68.9844 34.6469 66.7658 34.6469H50.7063",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2342 34.6469C11.0156 34.6469 9.2193 32.8506 9.2193 30.6321C9.2193 28.4135 11.0156 26.6172 13.2342 26.6172",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0743 26.6172V34.6469",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9702 44.0151C39.3614 44.0151 45.3531 38.0233 45.3531 30.6322C45.3531 23.241 39.3614 17.2493 31.9702 17.2493C24.5791 17.2493 18.5873 23.241 18.5873 30.6322C18.5873 38.0233 24.5791 44.0151 31.9702 44.0151Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6469 29.2939V31.9705",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2936 25.2791V35.9854",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9405 29.2939V31.9705",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 27.9556V33.3087",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4074 37.3918L54.8164 47.8008C56.3836 49.3681 56.3836 51.9108 54.8164 53.4781C53.2491 55.0454 50.7063 55.0454 49.139 53.4781L38.7301 43.0692",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_752_1003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 61.2639,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1BillionHoverstage);
export default __webpack_public_path__ + "static/media/1_Billion_Hoverstage.0fbf592f15bbfc20d92cbd5937c2dbc6.svg";
export { ForwardRef as ReactComponent };